import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/naslov.css';

const PravilaPrivatnosti = () => {
  return (
    <>
      <Helmet>
        <title>Pravila Privatnosti i Uvjeti Korištenja | Konto Zona</title>
        <meta name="description" content="Pravila privatnosti i uvjeti korištenja Konto Zone. Informacije o zaštiti osobnih podataka, kolačićima, kontakt formi i korištenju materijala." />
        <meta name="keywords" content="pravila privatnosti, uvjeti korištenja, zaštita podataka, GDPR, kolačići" />
        <meta property="og:title" content="Pravila Privatnosti i Uvjeti Korištenja | Konto Zona" />
        <meta property="og:description" content="Pravila privatnosti i uvjeti korištenja Konto Zona web stranice. Informacije o zaštiti osobnih podataka." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://instrukcijekontozona.hr/pravila-privatnosti" />
        <meta property="og:image" content="https://instrukcijekontozona.hr/kontozona-logo.png" />
        <meta property="og:locale" content="hr_HR" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pravila Privatnosti i Uvjeti Korištenja | Konto Zona" />
        <meta name="twitter:description" content="Pravila privatnosti i uvjeti korištenja Konto Zona web stranice. Informacije o zaštiti osobnih podataka." />
        <meta name="twitter:image" content="https://instrukcijekontozona.hr/kontozona-logo.png" />
        <link rel="canonical" href="https://instrukcijekontozona.hr/pravila-privatnosti" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Pravila Privatnosti i Uvjeti Korištenja",
            "description": "Pravila privatnosti i uvjeti korištenja Konto Zone. Informacije o zaštiti osobnih podataka, kolačićima, kontakt formi i korištenju materijala.",
            "url": "https://instrukcijekontozona.hr/pravila-privatnosti",
            "isPartOf": {
              "@type": "WebSite",
              "name": "Konto Zona",
              "url": "https://instrukcijekontozona.hr"
            }
          })}
        </script>
      </Helmet>
      {/* HERO SECTION */}
      <section className="section hero-final pravila-hero" style={{ 
        padding: '80px 0 40px 0',
        background: 'linear-gradient(135deg, #f0f8ff 0%, #f0fff0 100%)'
      }}>
        <div className="container text-center">
          <h1 style={{ 
            fontSize: 'clamp(2rem, 5vw, 3rem)', 
            color: '#1F2937', 
            marginBottom: '1rem',
            fontWeight: 700
          }}>
            Pravila Privatnosti i Uvjeti Korištenja
          </h1>
          <p style={{ 
            fontSize: '1.1rem', 
            color: '#6B7280',
            marginBottom: '0'
          }}>
            Zadnje ažurirano: 10. kolovoza 2025.
          </p>
        </div>
      </section>

      {/* CONTENT SECTION */}
      <div className="section" style={{ 
        paddingTop: '40px',
        background: 'linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)'
      }}>
        <div className="container">

        <div style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }}>
          <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
            Dobrodošli u Konto Zonu. Korištenjem naše web-stranice, usluga ili proizvoda potvrđujete da ste
            pročitali, razumjeli i prihvaćate sve odredbe navedene u ovom dokumentu.
          </p>

          <h2 style={{ color: '#0072CE', marginTop: '3rem', marginBottom: '1.5rem' }}>Pravila o Zaštiti Privatnosti</h2>

          <h3 style={{ color: '#1F2937', marginTop: '2rem', marginBottom: '1rem' }}>1. Uvodne odredbe</h3>
          <p>
            Konto Zona, obrt za instrukcije i poduke (u daljnjem tekstu: KZ), posvećen je zaštiti vaše
            privatnosti. Ova Pravila detaljno objašnjavaju koje osobne podatke prikupljamo, kako ih
            obrađujemo, štitimo te koja su vaša prava u skladu s Općom uredbom o zaštiti podataka
            (GDPR).
          </p>

          <h3 style={{ color: '#1F2937', marginTop: '2rem', marginBottom: '1rem' }}>2. Voditelj obrade podataka</h3>
          <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            <li>• <strong>Naziv:</strong> Konto Zona, obrt za instrukcije i poduke, vl. Marko Pačalat</li>
            <li>• <strong>Adresa:</strong> Diljska ulica 26, Zagreb, Hrvatska</li>
            <li>• <strong>OIB:</strong> 98978576142</li>
            <li>• <strong>Službeni email za pitanja o privatnosti:</strong> konto.zona@gmail.com</li>
          </ul>

          <h3 style={{ color: '#1F2937', marginTop: '2rem', marginBottom: '1rem' }}>3. Koje podatke prikupljamo i zašto?</h3>
          <p>
            KZ prikuplja isključivo nužne osobne podatke koje nam vi dobrovoljno pružite u sljedećim
            situacijama:
          </p>
          <ul>
            <li><strong>Kada nas kontaktirate</strong> (kontakt forma, e-mail, WhatsApp): Vaše ime, prezime i kontakt
              podatke (e-mail, broj telefona) kako bismo mogli odgovoriti na vaš upit i dogovoriti
              uslugu.</li>
            <li><strong>Kada se prijavite na newsletter:</strong> Vašu e-mail adresu uz vašu izričitu privolu, za slanje
              obavijesti i ponuda.</li>
            <li><strong>Kada sudjelujete u anketama:</strong> Vaše odgovore i mišljenja, isključivo radi unapređenja
              našeg rada.</li>
          </ul>

          <h3 style={{ color: '#1F2937', marginTop: '2rem', marginBottom: '1rem' }}>4. Upotreba Kolačića (Cookies) i Analitika</h3>
          
          <h4 style={{ color: '#1F2937', marginTop: '1.5rem', marginBottom: '0.5rem' }}>Što su kolačići?</h4>
          <p>
            Kolačić je mala tekstualna datoteka koju web stranica sprema na vaše računalo ili mobilni
            uređaj kada je posjetite. Kolačići nam omogućuju da poboljšamo vaše korisničko iskustvo i
            analiziramo promet.
          </p>

          <h4 style={{ color: '#1F2937', marginTop: '1.5rem', marginBottom: '0.5rem' }}>Vrste kolačića koje koristimo:</h4>
          <ul>
            <li><strong>Nužni kolačići:</strong> Ovi kolačići su neophodni za osnovno funkcioniranje web stranice. Za
              njih nije potrebna vaša privola.</li>
            <li><strong>Analitički i statistički kolačići:</strong> Uz vašu privolu, koristimo ove kolačiće kako bismo
              razumjeli kako posjetitelji koriste našu web stranicu prikupljanjem i izvještavanjem
              anonimnih informacija. Ovi podaci nam pomažu da optimiziramo stranicu i sadržaj.</li>
          </ul>

          <h4 style={{ color: '#1F2937', marginTop: '1.5rem', marginBottom: '0.5rem' }}>Vaša privola:</h4>
          <p>
            Prilikom vašeg prvog posjeta stranici, zatražit ćemo vašu izričitu privolu za korištenje analitičkih
            kolačića putem obavijesti (tzv. "cookie banner"). Imate puno pravo odbiti korištenje ovih
            kolačića. Svoju privolu možete povući u bilo kojem trenutku.
          </p>

          <h4 style={{ color: '#1F2937', marginTop: '1.5rem', marginBottom: '0.5rem' }}>Google Analytics:</h4>
          <p>
            Koristimo uslugu Google Analytics za analizu prometa. Podaci koje prikupljamo su anonimni
            (vaša IP adresa je maskirana) i ne mogu se koristiti za vašu osobnu identifikaciju.
          </p>

          <h3 style={{ color: '#1F2937', marginTop: '2rem', marginBottom: '1rem' }}>5. Koliko dugo čuvamo vaše podatke i koja su vaša prava?</h3>
          <p>
            Podatke čuvamo onoliko dugo koliko je potrebno za svrhu za koju su prikupljeni. U svakom
            trenutku imate pravo zatražiti pristup, ispravak ili brisanje svojih podataka slanjem zahtjeva na
            naš službeni email. Ako smatrate da je došlo do povrede vaših prava, imate pravo podnijeti
            prigovor nadležnom tijelu – Agenciji za zaštitu osobnih podataka (AZOP).
          </p>

          <h2 style={{ color: '#0072CE', marginTop: '3rem', marginBottom: '1.5rem' }}>Uvjeti Korištenja</h2>

          <h3 style={{ color: '#1F2937', marginTop: '2rem', marginBottom: '1rem' }}>1. Intelektualno vlasništvo</h3>
          <p>
            Sav sadržaj i materijali koje KZ pruža – uključujući PDF zapisnike, autorske skripte, radne listove i
            kvizove – isključivo su intelektualno vlasništvo obrta Konto Zona i zaštićeni su Zakonom o
            autorskom pravu i srodnim pravima. Kupnjom stječete ograničenu, neprenosivu licencu
            isključivo za vašu osobnu, nekomercijalnu upotrebu.
          </p>

          <h3 style={{ color: '#1F2937', marginTop: '2rem', marginBottom: '1rem' }}>2. Stroga zabrana neovlaštenog dijeljenja i pravne posljedice</h3>
          <p>
            Izričito je zabranjeno svako neovlašteno kopiranje, reproduciranje, javno dijeljenje,
            distribuiranje, prosljeđivanje ili preprodavanje naših materijala trećim osobama (putem emaila, WhatsApp grupa, Telegrama, društvenih mreža, platformi za dijeljenje datoteka i sl.).
          </p>
          <p>
            Svaki takav čin smatra se teškom povredom autorskih prava i ovih Uvjeta korištenja. U
            slučaju takve povrede, KZ zadržava pravo poduzeti sve raspoložive pravne radnje, uključujući, ali
            ne ograničavajući se na, pokretanje građanske parnice za naknadu štete. U skladu sa
            Zakonom o autorskom pravu i srodnim pravima, ovisno o opsegu neovlaštene distribucije i
            procijenjenoj izgubljenoj dobiti, iznos naknade štete koji će se potraživati može iznositi od
            1.500,00 EUR do 10.000,00 EUR, a potencijalno i više.
          </p>

          <h3 style={{ color: '#1F2937', marginTop: '2rem', marginBottom: '1rem' }}>3. Financijske odredbe</h3>
          <ul>
          <li><strong>Potvrda Termina:</strong> Mjesto u našem rasporedu smatra se rezerviranim tek nakon izvršene uplate. Time osiguravamo vaš termin i našu potpunu posvećenost.</li>
            <li><strong>Otkazivanje:</strong> Otkazivanje je potrebno javiti najmanje 48 sati unaprijed. Za otkazivanja
              unutar 48 sati, termin se smatra iskorištenim.</li>
            <li><strong>Kašnjenje:</strong> Cijenimo vaše vrijeme, jednako kao i svoje. Zato vas vaš termin uvijek čeka 15 minuta u slučaju nepredviđenih poteškoća. Nakon tog perioda, kako bismo održali princip uzajamnog poštovanja, sat se nažalost mora smatrati održanim.</li>

            <li><strong>Povrat novca:</strong> KZ ne vrši povrat novca. U slučaju pravovremenog otkazivanja (48h+
              unaprijed), uplaćeni iznos se pretvara u kredit koji možete iskoristiti za novi termin
              unutar 30 dana.</li>
          </ul>

          <h3 style={{ color: '#1F2937', marginTop: '2rem', marginBottom: '1rem' }}>4. Odricanje od odgovornosti</h3>
          <p>
            KZ pruža vrhunske edukativne usluge, no ne jamčimo specifične rezultate ili ocjene. Vaš
            uspjeh ovisi o vašem osobnom angažmanu i trudu.
          </p>

          <h3 style={{ color: '#1F2937', marginTop: '2rem', marginBottom: '1rem' }}>5. Završne odredbe</h3>
          <p>
            KZ zadržava pravo izmjene ovih Uvjeta u bilo kojem trenutku. Za sva pitanja, kontaktirajte nas na:
            <a href="mailto:konto.zona@gmail.com" style={{ color: '#00c300' }}> konto.zona@gmail.com</a>.
          </p>
        </div>
      </div>
    </div>
    </>
  );
};

export default PravilaPrivatnosti; 